// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "18b16e15" + "." + "e6aeda0d3591583a" + ".js";
};